import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

import config from 'config';

export type InitParams = {
  dsn?: string;
  environment?: string;
  release?: string;
};

abstract class LoggerService {
  private static captureException(m: string, e) {
    return Sentry.captureMessage(m, e);
  }

  public static init({ dsn, environment, release }: InitParams) {
    if (config.app.env === 'local') return;

    Sentry.init({
      dsn,
      environment,
      release,
      autoSessionTracking: true,
      integrations: [new Integrations.BrowserTracing()],
      tracesSampleRate: 1.0,
      attachStacktrace: true
    });
  }

  public static log(message: string, e) {
    switch (config.app.env) {
      case 'production':
      case 'staging':
      case 'development': {
        LoggerService.captureException(message, e);
        break;
      }

      case 'local':
      default: {
        if (e) {
          console.error(message, e);
        } else {
          console.log(message);
        }

        break;
      }
    }
  }
}

export default LoggerService;
